import React from 'react'
import { pick } from 'lodash'
import classes from 'classnames'
import { ShareButtons } from 'react-share'
import { FormattedMessage } from 'react-intl'

export default ({ isMobile, isAbsolute, className = 'Sidebar__share', meta = {} }) => {
  const href = window ? window.location.href : null
  return (
    <div className={classes(className, { 'Sidebar__share_absolute': isAbsolute })}>
      <FormattedMessage id='sidebar_share.share' />
      <div className='Sidebar__share-body'>
        <ShareButtons.FacebookShareButton url={href} quote={meta.description}>
          <span className='Link Link_light Link_single'>
            <FormattedMessage id='sidebar_share.facebook' />
          </span>
        </ShareButtons.FacebookShareButton>
        <ShareButtons.VKShareButton url={href} {...pick(meta, [ 'title' ])}>
          <span className='Link Link_light Link_single'>
            <FormattedMessage id='sidebar_share.vk' />
          </span>
        </ShareButtons.VKShareButton>
        <ShareButtons.TwitterShareButton url={href} {...pick(meta, [ 'title', 'description', 'image' ])}>
          <span className='Link Link_light Link_single'>
            <FormattedMessage id='sidebar_share.twitter' />
          </span>
        </ShareButtons.TwitterShareButton>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Share.jsx